import dynamic from 'next/dynamic';
import { useEffect } from 'react';
import BackToTopButton from '@/components/collections/BackToTopButton';
import { DealsResults } from './types';
import { QsContext, useQs } from '@/lib/use-qs';
import HotDealsLayout from './HotDealsLayout';

const Marketplace = dynamic(() => import('@/components/commons/Marketplace'));

const SeoHotDeals = dynamic(
  () => import('@/components/collections/hotDeals/SeoHotDeals'),
);

export default function HotDealsNavPage(props: DealsResults) {
  const [qs, updateQs] = useQs<string>();

  useEffect(() => {
    updateQs({
      categories: qs?.categories,
      brand: qs?.brand,
      dealTypes: qs.dealTypes,
    });
  }, []);

  return (
    <QsContext.Provider value={[qs, updateQs]}>
      <BackToTopButton />
      <div className="bg-white">
        <HotDealsLayout {...props} />
        <section className="bg-teal-500 pt-8">
          <Marketplace view="default" />
        </section>
      </div>
      <div className="reebelo-container pb-14">
        <SeoHotDeals />
      </div>
    </QsContext.Provider>
  );
}
